// extracted by mini-css-extract-plugin
module.exports = {"paddingor":"RandomQuote_paddingor__1vXS9","rowSpacing":"RandomQuote_rowSpacing__2eOSp","topRightor":"RandomQuote_topRightor__1Ng8i"};